<script setup></script>

<template>
  <main
    class="layout-default"
    :class="[$route.path === '/' ? 'homepage' : 'standard-page']"
  >
    <SeoTemplatePreset>
      <NavigationHeader />
      <slot />
      <Footer />
    </SeoTemplatePreset>
  </main>
</template>
